// Frontend mirror of backend.business_logic.compute_invoice_totals.
// Keeps the form UI in sync with the persisted server-side calculation.

export const computeInvoiceTotals = (items, fdType, fdValue, tax = {}, settings = {}) => {
  const safe = (v, d = 0) => {
    if (v === null || v === undefined || v === '') return Number(d) || 0;
    const n = Number(v);
    return Number.isFinite(n) ? n : Number(d) || 0;
  };

  let subtotal = 0;
  for (const it of items || []) {
    const sub = Math.max(0, safe(it.quantity) * safe(it.unit_price) - safe(it.discount));
    subtotal += sub;
  }
  subtotal = Math.round(subtotal * 100) / 100;

  let fdAmt = 0;
  const t = (fdType || 'nominal').toLowerCase();
  const v = Math.max(0, safe(fdValue));
  if (t === 'percent') {
    fdAmt = Math.min(subtotal, (subtotal * Math.min(100, v)) / 100);
  } else {
    fdAmt = Math.min(subtotal, v);
  }
  fdAmt = Math.round(fdAmt * 100) / 100;

  const dpp = Math.max(0, Math.round((subtotal - fdAmt) * 100) / 100);

  const includePpn = !!tax.include_ppn;
  // ----- e-Faktur (DPP Nilai Lain) -----
  // DPP Nilai Lain = DPP × 11/12
  // PPN = 12% × DPP Nilai Lain
  // Grand Total = DPP + PPN
  const ppnRateInternal = 12;
  const multiplier = Number.isFinite(Number(settings.default_dpp_nilai_lain_multiplier))
    ? Number(settings.default_dpp_nilai_lain_multiplier)
    : 11 / 12;
  let dppNilaiLain = 0;
  let ppnAmount = 0;
  if (includePpn) {
    dppNilaiLain = Math.round(dpp * multiplier * 100) / 100;
    ppnAmount = Math.round((dppNilaiLain * ppnRateInternal) / 100 * 100) / 100;
  }

  const grandTotal = Math.round((dpp + ppnAmount) * 100) / 100;

  const includeWht = !!tax.include_withholding_tax;
  const whtRate = safe(tax.withholding_tax_rate, safe(settings.default_withholding_tax_rate, 2));
  let whtBaseKind = (tax.withholding_tax_base || settings.default_withholding_tax_base || 'dpp').toLowerCase();
  if (!['dpp', 'gross_invoice', 'custom'].includes(whtBaseKind)) whtBaseKind = 'dpp';

  let whtBaseAmount = 0;
  let whtAmount = 0;
  if (includeWht) {
    if (whtBaseKind === 'dpp') whtBaseAmount = dpp;
    else if (whtBaseKind === 'gross_invoice') whtBaseAmount = grandTotal;
    else whtBaseAmount = safe(tax.withholding_tax_custom_base);
    whtAmount = Math.round(Math.max(0, whtBaseAmount) * whtRate / 100 * 100) / 100;
  }

  const netToCollect = Math.max(0, Math.round((grandTotal - whtAmount) * 100) / 100);

  let whtStatus;
  if (includeWht) {
    whtStatus = tax.withholding_status === 'Received' || tax.withholding_status === 'Waiting'
      ? tax.withholding_status
      : 'Waiting';
  } else {
    whtStatus = 'Not Required';
  }

  return {
    subtotal_amount: subtotal,
    final_discount_amount: fdAmt,
    dpp_amount: dpp,
    include_ppn: includePpn,
    ppn_rate: ppnRateInternal,
    ppn_amount: ppnAmount,
    dpp_nilai_lain_amount: dppNilaiLain,
    grand_total_amount: grandTotal,
    invoice_gross_amount: grandTotal,
    include_withholding_tax: includeWht,
    withholding_tax_type: tax.withholding_tax_type || settings.default_withholding_tax_type || 'PPh',
    withholding_tax_rate: whtRate,
    withholding_tax_base: whtBaseKind,
    withholding_tax_custom_base: safe(tax.withholding_tax_custom_base),
    withholding_tax_amount: whtAmount,
    withholding_status: whtStatus,
    net_amount_to_collect: netToCollect,
  };
};
